export default {
    "deletePaymentToken": "5eaeff0aa83ffe734da704cc1bb43fd35196d058b951d8145ee255d9ab66dbd3"
};
